<div class="container py-64 min-h-100vh">
    <div class="row justify-content-center">
        <div class="col-md-12 col-lg-8">
            <div class="tm-card card-maintenance">
                <div class="card-body">
                    <div class="maintenance-content-wrapper">
                        <div class="img-wrapper">
                            <img src="/assets/media/under-maintenance.png" alt="under maintenance" width="186">
                        </div>
                        <div class="maintenance-title">
                            <h2>المنصة تحت الصيانة</h2>
                            <p>
                                "نحن نقوم حاليًا بإجراء بعض التحسينات الهامة على موقعنا لضمان تقديم أفضل تجربة ممكنة.
                                نشكركم على صبركم وتفهمكم."
                            </p>
                        </div>
                        <div class="maintenance-timer">
                            <p class="timer-title">من المقدر أن نعود خلال</p>
                            <div class="timer-wrapper">
                                <div class="timer">
                                    <div class="day">
                                        <span>{{remainingTime.days}}</span>
                                        <span>يوم</span>
                                    </div>
                                    <div class="hour">
                                        <span>{{remainingTime.hours}}</span>
                                        <span>ساعة</span>
                                    </div>
                                    <div class="minute">
                                        <span>{{remainingTime.minutes}}</span>
                                        <span>دقيقة</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="maintenance-footer">
                            <p>
                                إذا كنتم بحاجة إلى المساعدة الفورية، يمكنكم التواصل
                                معنا عبر البريد الإلكتروني
                               <a href="mailto:tallam@info.com"><span> tallam&#64;info.com</span></a>
                            </p>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>